var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_509_3537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3809 -6.10352e-05H2.61905C1.1749 -6.10352e-05 0 1.17484 0 2.61899V19.3809C0 20.825 1.1749 21.9999 2.61905 21.9999H19.3809C20.8251 21.9999 22 20.825 22 19.3809V2.61899C22 1.17484 20.8251 -6.10352e-05 19.3809 -6.10352e-05ZM17.2889 9.5977C17.1687 9.60937 17.0481 9.61549 16.9274 9.61603C16.2758 9.61612 15.6343 9.45393 15.061 9.1441C14.4877 8.83427 14.0006 8.38656 13.6437 7.84136V13.8846C13.6437 14.7679 13.3817 15.6315 12.8909 16.366C12.4001 17.1005 11.7026 17.673 10.8864 18.0111C10.0703 18.3491 9.17218 18.4376 8.30576 18.2653C7.43934 18.0929 6.64349 17.6675 6.01883 17.0429C5.39418 16.4182 4.96878 15.6223 4.79644 14.7559C4.6241 13.8895 4.71255 12.9914 5.05061 12.1753C5.38867 11.3591 5.96116 10.6616 6.69567 10.1708C7.43019 9.67999 8.29375 9.41803 9.17714 9.41803C9.27038 9.41803 9.36152 9.42641 9.45319 9.43217V11.6332C9.36152 11.6222 9.27143 11.6055 9.17714 11.6055C8.57255 11.6055 7.99272 11.8456 7.56521 12.2731C7.13769 12.7007 6.89752 13.2805 6.89752 13.8851C6.89752 14.4897 7.13769 15.0695 7.56521 15.497C7.99272 15.9245 8.57255 16.1647 9.17714 16.1647C10.4364 16.1647 11.5484 15.1726 11.5484 13.9134L11.5704 3.64984H13.6761C13.7723 4.56477 14.1871 5.41678 14.8479 6.05687C15.5087 6.69697 16.3734 7.08443 17.2909 7.15151V9.5977",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_509_3537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.52585662f302d1f0397388bffc4ddbcc.svg";
export { ForwardRef as ReactComponent };